import { GreenCheck } from '@odmonorepo/core-components';
import React from 'react';
import { Row, Col, Stack } from 'react-bootstrap';

export interface TripleGreenCheckProps {
  text1: any;
  text2: any;
  text3: any;
}

export const TripleGreenCheck = ({ text1, text2, text3 }: TripleGreenCheckProps) => {
  return (
     <Stack>
      <Row className="fw-bold">
        <Col className="d-flex my-3 px-4 text-start">
          <GreenCheck className='me-2'/>
          {text1}
        </Col>
      </Row>
      <Row className="fw-bold">
        <Col className="d-flex my-3 px-4 text-start">
          <GreenCheck className='me-2'/>
          {text2}
        </Col>
      </Row>
      <Row className="fw-bold">
        <Col className="d-flex my-3 px-4 text-start">
          <GreenCheck className='me-2'/>
          {text3}
        </Col>
      </Row>
    </Stack>
  );
};

export default TripleGreenCheck;